// src/services/classMapService.js — teacher actions on the class treasure map
// (functions/classMap.js)

import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase/firebaseConfig";

const call = async (name, data) => {
  try {
    const res = await httpsCallable(functions, name)(data);
    return res.data;
  } catch (err) {
    throw new Error(String(err?.message || "Something went wrong — please try again.").replace(/^.*?:\s*/, ""));
  }
};

export const sendCheer = (studentUid, message) => call("sendCheer", { studentUid, message });
export const setMapGoal = (subjectKey, target, by = "", title = "") => call("setMapGoal", { subjectKey, target, by, title });

export const CHEERS = ["Great job! 🌟", "Keep going! 💪", "I'm proud of you! 🎉", "You're a star! ⭐", "Super effort today! 🚀", "Way to never give up! 🏆"];
